import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BlogStateTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BlogStateTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.1159 9.47992C20.0574 9.47992 21.6313 7.90605 21.6313 5.96457C21.6313 4.0231 20.0574 2.44922 18.1159 2.44922C16.1745 2.44922 14.6006 4.0231 14.6006 5.96457C14.6006 7.90605 16.1745 9.47992 18.1159 9.47992Z"
        fill="#FC3B26"
      />
      <path
        d="M20.9976 9.42651C20.9976 9.1497 21.222 8.92529 21.4988 8.92529C21.7756 8.92529 22 9.1497 22 9.42651V11.2241H20.9976V9.42651Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.3983 3.42724C14.6114 3.11548 14.4071 2.62207 14.0295 2.62207H3.55273C2.69678 2.62207 2 3.31836 2 4.17432V19.8242C2 20.6802 2.69677 21.3769 3.55273 21.3769H19.7046L19.7167 21.3768L19.7422 21.3769C20.9873 21.3769 22 20.3638 22 19.1187V10.0602C22 10.0478 21.9999 10.0341 21.9996 10.0191C21.9944 9.75537 21.6118 9.44947 21.3629 9.36202C21.1467 9.28605 21 9.55057 21 9.77974V19.1186C21 19.8125 20.4355 20.3769 19.7422 20.3769C19.0483 20.3769 18.4839 19.8125 18.4839 19.1186V10.8176C18.4839 10.619 18.3143 10.4639 18.1157 10.4639C17.7809 10.4639 17.4839 10.7189 17.4839 11.0537V19.8242C17.4839 20.0414 17.622 20.226 17.8152 20.2951C17.8322 20.3228 17.8497 20.3501 17.8678 20.3769H3.55273C3.24805 20.3769 3 20.1289 3 19.8242V4.17432C3 3.86963 3.24804 3.62207 3.55273 3.62207H14.0409C14.1846 3.62207 14.3172 3.54588 14.3983 3.42724Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.6924 7.73145C13.8645 7.73145 14.019 7.8364 14.0966 7.99C14.258 8.30964 14.0441 8.73145 13.686 8.73145H7.33448C7.05811 8.73145 6.83448 8.50782 6.83448 8.23145C6.83448 7.95508 7.05811 7.73145 7.33448 7.73145H13.6924Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8701 12.5508H5.47656C5.20019 12.5508 4.97656 12.3272 4.97656 12.0508C4.97656 11.7744 5.20019 11.5508 5.47656 11.5508H14.8701C15.1465 11.5508 15.3701 11.7744 15.3701 12.0508C15.3701 12.3272 15.1465 12.5508 14.8701 12.5508Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.47656 16.3701H14.8701C15.1465 16.3701 15.3701 16.1465 15.3701 15.8701C15.3701 15.5938 15.1465 15.3701 14.8701 15.3701H5.47656C5.20019 15.3701 4.97656 15.5938 4.97656 15.8701C4.97656 16.1465 5.20019 16.3701 5.47656 16.3701Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4805 10.7381C17.4805 10.4613 17.7049 10.2369 17.9817 10.2369C18.2585 10.2369 18.4829 10.4613 18.4829 10.7381V12.5358H17.4805V10.7381Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BlogStateTrueIcon;
